/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { SafeString } from 'handlebars';
import { htmlSafe } from '@ember/template';
import { typeOf } from '@ember/utils';

interface TriggerJsonFormatterArgs {
  data: unknown[] | Record<string, unknown> | null;
  pathsUsed?: string[];
  onItemClick?: (value: string, event?: Event) => unknown;
  highlightedPath?: string;
  canClickItems?: boolean;
  theme?: 'dark' | 'light';
  collapseRoot?: boolean;
  mouseEvent?: 'click' | 'mousedown';
  itemPaddingLeft?: number;
}

export default class TriggerJsonFormatter extends Component<TriggerJsonFormatterArgs> {
  get pathsUsed() {
    return this.args.pathsUsed ?? [];
  }

  get mouseEvent() {
    return this.args.mouseEvent ?? 'click';
  }

  get theme() {
    return this.args.theme ?? 'dark';
  }

  get collapseRoot() {
    return this.args.collapseRoot ?? false;
  }

  get canClickItems() {
    return this.args.canClickItems ?? false;
  }

  get itemPaddingLeft() {
    return this.args.itemPaddingLeft ?? 0;
  }

  get isArray() {
    if (this.args.data == null) {
      return false;
    }

    return typeOf(this.args.data) === 'array';
  }

  get rootItem() {
    if (this.args.data == null) {
      return null;
    }

    if (this.isArray) {
      return {
        key: '',
        value: this.args.data,
        isArrayItem: true,
      };
    }

    return {
      key: '',
      value: this.args.data,
    };
  }

  widthReferenceContainerElement: HTMLElement | null = null;
  widthReferenceContainerResizeObserver: ResizeObserver | null = null;

  @tracked iconOffsetStyle: SafeString = htmlSafe('');

  @action
  didInsertWidthReferenceContainer(widthReferenceContainer: HTMLElement) {
    this.widthReferenceContainerElement = widthReferenceContainer;

    this.widthReferenceContainerResizeObserver = new ResizeObserver(() =>
      requestAnimationFrame(this.calculateIconOffset),
    );
    this.widthReferenceContainerResizeObserver.observe(this.widthReferenceContainerElement);
  }

  @action
  calculateIconOffset() {
    if (this.widthReferenceContainerElement == null) {
      return;
    }

    // clientWidth is the width of the element without the scrollbar
    let width = this.widthReferenceContainerElement.clientWidth;
    this.iconOffsetStyle = htmlSafe(`left: ${width - 24}px;`);
  }

  @action
  onItemClick(value: string, event?: Event) {
    if (this.args.onItemClick == null) {
      return;
    }

    return this.args.onItemClick(value, event);
  }
}
